import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Octagon = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M51.656 0.189117H21.8192L0.720337 21.287V51.1248L21.8192 72.2227H51.656L72.7549 51.1248V21.287L51.656 0.189117Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
